import EmployeeEnrollmentController from "./EmployeeEnrollmentController";
import "./EmployeeEnrollment.css";
import { ToastContainer } from "react-toastify";
// import useFormattedDate from "../../../../context/useFormattingUtils";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import SalesInvoiceTable from "../../AppPAges/Dashboard/Invoice/SalesInvoiceTable";
import { useState } from "react";
const EmployeeEnrollmentView = () => {
  const { GetPaginatedData } = useApi();
  const {

    enrolledEmployees,
    selectedEmployeeObj,
    selectedBiometricEmployeeObj,
    handleEmployeeChange,
    handleBiometricEmployeeChange,
    handleSubmit,
    handleDeleteEnrollment,
    getEnrolledEmployeesData,
    debouncedGetEnrolledEmployeesData,
    isLoadingData,
    totalPages,
    totalCount
  } = EmployeeEnrollmentController();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  // const { formatDate } = useFormattedDate();


  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
    debouncedGetEnrolledEmployeesData(1, term);
  };


  const handlePageChange = (page) => {
    setCurrentPage(page);
    getEnrolledEmployeesData(page, searchTerm);
  };


   const formattedEnrolledEmployees = enrolledEmployees.map(item => ({
    ...item,
    request_active: item.request_active ? "Yes" : "No",
    is_registered: item.is_registered ? "Yes" : "No"
  }));


  const columns = [

    { header: "Employee Name", field: "employee_name" },
    { header: "Biometric User Name", field: "biometric_user_name" },
    { header: "Request Active", field: "request_active" },
    { header: "Is Registered", field: "is_registered" },
    { header: "Created At", field: "created_at" },
  ];

  
  return (
    <>
   <ToastContainer/>
      <div className="responsive-box">
        <div className="employee-header">
          <div className="employee-title">Employee Enrollment</div>
        </div>
        <div className="d-flex justify-content-center align-items-center mb-4 mt-4">
          <form className="d-flex align-items-center" style={{ gap: "25px", flexWrap: "wrap" }}>
            <div className="d-flex flex-column" style={{ width: "300px" }}>
              <PaginatedSearchSelect
                api="user"
                GetPaginatedData={GetPaginatedData}
                getOptionLabel={(opt) => `${opt.first_name} ${opt.last_name || ""}`}
                onSelect={(opt) => handleEmployeeChange(opt)}
                placeholder="Select Employee"
                value={selectedEmployeeObj}
                style={{ width: "300px" }}
                pageSize={20}
                filterFn={(user) => user.ms_role_name === "store employee" || user.ms_role_name === "store manager"}
              />
            </div>
            <div className="d-flex flex-column" style={{ width: "300px" }}>
              <PaginatedSearchSelect
                api="user"
                GetPaginatedData={GetPaginatedData}
                getOptionLabel={(opt) => `${opt.first_name} ${opt.last_name || ""}`}
                onSelect={(opt) => {
                  handleBiometricEmployeeChange(opt)}}
                placeholder="Select Biometric User"
                value={selectedBiometricEmployeeObj}
                style={{ width: "300px" }}
                pageSize={20}
                filterFn={(user) => user.ms_role_name === "biometric_user"}
              />
            </div>
            <button
              type="button"
              id="save-button"
              onClick={handleSubmit}
              className="btn"
              style={{
                width: "150px",
                height: "52px",
                padding: "5px 10px",
                fontSize: "16px",
                fontWeight: "700",
                color: "#f4ffee",
                backgroundColor: "#4a5546",
                border: "none",
                borderRadius: "40px",
                cursor: "pointer",
                marginBottom: "25px"
              }}
            >
              Save
            </button>
          </form>
        </div>
        <SalesInvoiceTable
          data={formattedEnrolledEmployees}
          columns={columns}
          showAction={false}
          showFooter={true}
          onDelete={handleDeleteEnrollment}
          showNo={true}
          loading={isLoadingData}
          currentPage={currentPage}
          totalCount={totalCount}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          searchTerm={searchTerm}
          onSearch={handleSearch}
        />
      </div>
    </>
  );
};
export default EmployeeEnrollmentView;